// extracted by mini-css-extract-plugin
export default {"fullWidth":"Ip-z","image":"Jp-z","lazyLoadPicture":"Kp-z","lazyLoadSpinner":"Lp-z","lazyLoadSpin":"Mp-z","lazyLoadImage":"Np-z","hasStyledAspectRatio":"Op-z"};